import { encodeEscPosChars, ESC_POS_CUT, ESC_POS_PROLOGUE } from './escposCharset';
import { receiptCharsPerLine, receiptPlainTextCols } from './format';
import { receiptCenterLineOnPaper } from './receiptPlainLayout';
import type { ReceiptWidthMm } from './types';

/** ESC/POS mínimo desde texto plano (comandas, precuenta). Centra en el ancho nativo del rollo. */
export function encodeEscPosPlainText(text: string, widthMm: ReceiptWidthMm = 72): Uint8Array {
  const contentCols = receiptPlainTextCols(widthMm);
  const paperCols = receiptCharsPerLine(widthMm);
  const bytes: number[] = [...ESC_POS_PROLOGUE];
  const normalized = text.endsWith('\n') ? text : `${text}\n`;
  for (const raw of normalized.split('\n')) {
    const line = receiptCenterLineOnPaper(raw, contentCols, paperCols);
    bytes.push(...encodeEscPosChars(`${line}\n`));
  }
  bytes.push(...ESC_POS_CUT);
  return Uint8Array.from(bytes);
}
